import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: "app-forbidden",
    imports: [CommonModule],
    templateUrl: "./forbidden.component.html",
    styleUrl: "./forbidden.component.scss"
})
export class ForbiddenComponent {}
